import {NearbyWaypoints} from 'UI/components/modules/NearbyWaypoints';

/**
 * Props for the NearbyWaypointsBlock component.
 */
interface ComponentProps {
    /**
     * The `testId` property represents a unique identifier assigned to a component for testing purposes.
     *
     * @default 'NearbyWaypointsBlock'
     */
    testId?: string;
}

/**
 * Homepage block wrapper around `NearbyWaypoints`. Has no configurable fields in the CMS — an
 * editor just adds it to the page's block list and positions it via drag-and-drop; it renders
 * nothing on its own until the visitor has enabled location sharing.
 *
 * @param props        The component props.
 * @param props.testId An optional test ID. Defaults to `'NearbyWaypointsBlock'`.
 * @returns A JSX element rendering the NearbyWaypoints section.
 *
 * @example
 * ```tsx
 * <NearbyWaypointsBlock />
 * ```
 */
const NearbyWaypointsBlock = ({testId = 'NearbyWaypointsBlock'}: ComponentProps) => <NearbyWaypoints testId={testId} />;

NearbyWaypointsBlock.displayName = 'NearbyWaypointsBlock';

export {NearbyWaypointsBlock};